import React, { useEffect, useState } from 'react';
import { Button } from "bootstrap-4-react/lib/components";
import { useSelector } from 'react-redux';
import { getPaymentToken } from '../../../store/actions/fundManagement';
import { useLocation, useNavigate } from 'react-router-dom';
import { findIsHostShipAi, formatNumberWithCommas, findConfiguration } from '../../../config/utils';
import moment from "moment";
import { Grid } from '@material-ui/core';
import '../modal.css';
import OtpInput from '../../common/OtpInput';
import { toast } from "react-toastify";
import { getCardSignature, getDetailsOfLoggedInUser } from '../../../store/actions';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

const Recharge = () => {
    const location = useLocation();
    const userDetails = useSelector((state) => state.auth.user);
    const navigate = useNavigate();
    const [agreeTnC, setAgreeTnC] = useState(false);
    const [userSignature, setUserSignature] = useState('');
    const [data, setLocationData] = useState(false);
    const [cardLast4Digits, setCardLast4Digits] = useState('');
    const [clientInfo, setClientInfo] = useState({});
    const minAmountRechargeConfig = useSelector(
        (state) => state?.auth?.configurations
      );
    useEffect(() => {
        if (!location?.state?.amount) {
            navigate('/fundManagement');
        } else {
            setLocationData(location.state);
            navigate(location.pathname, { replace: true });
        }
        
    }, []);

    const getSignature = async () => {
        try {
            const response = await getCardSignature();
            if (response?.data?.Status === 200) {
                setUserSignature(response?.data?.Entity?.signatureUrl);
            }
        } catch (error) {
            console.error('Error fetching card signature:', error);
        }
    }
    
    const fetchUserDetails = async () => {
        try {
          const response = await getDetailsOfLoggedInUser();
            if (response?.data?.Status === 200) {
                const entity = response.data.Entity;
                const address = entity?.companyAddressModels?.[0];
                setClientInfo({
                    address: [address?.addressFirst, address?.addressSecond, address?.city, address?.state, address?.zipCode, address?.country].filter(Boolean).join(', '),
                    phone: address?.phoneNumber,
                    email: entity?.email,
                    company: entity?.selectedCompanyIds?.[0]?.CompanyName,
                });
            }
        } catch (error) {
          console.error('Error fetching user details:', error);
        }
    };

    useEffect(() => {
        fetchUserDetails();
        getSignature();
    }, []);

    const roleName = (userDetails?.Value?.roleName || '').toString().trim().toLowerCase();
    const isApprovedSeller = ['seller', 'admin'].includes(roleName);

    const recharge = async () => {
        const response = await getPaymentToken({
            ...data,
            creditCardLastFourDigits: cardLast4Digits,
            userId: userDetails?.Value?.employeeId,
        }, isApprovedSeller);
        if (response?.data?.Status === 200) {
        localStorage.setItem('userRecharge', JSON.stringify({
            token: response?.data?.Entity?.Token,
            processingFees: data?.processingFees,
            amount: data?.amount,
            description: data?.description,
            shouldSendEmail: data?.shouldSendEmail,
            email: data?.email,
            createdDate: moment(data?.createdDate).format("MM-DD-YYYY HH:mm:ss"),
        }));
        }
        else if (response?.data?.Status === 400) {
        toast.error(response?.data?.Message?.AppStatusDescription);
        }
        
        if (localStorage.getItem("userRecharge")) {
            const url = "/Payment/paymentf.html";
            window.location.href = url;
        }
    }

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    Transaction Summary
                    <div className="top_right_button_container"></div>
                </div>
                <Grid container spacing={2} className="mb-2">
                    <Grid item xs={12} md={6}>
                        <div className="billingAgreement main_content_table">
                            <div className="agreement-header">
                                <h3 className="agreement-title">CREDIT CARD BILLING AUTHORIZATION AGREEMENT</h3>
                                <div className="agreement-date">Date: {moment().format('DD MMMM YYYY')}</div>
                            </div>
                            <div className="agreement-content">
                                <div className="agreement-text-wrapper">
                                    <div className="agreement-authorization">
                                        I, <b>{userDetails?.Value?.sellerName}</b>{clientInfo?.company ? <> representing <b>{clientInfo.company}</b></> : ''}, authorize Minrak Inc (Cross Culture Mall - this is what will appear on your credit card statement) to charge my bill directly to the credit card/s listed below.
                                    </div>
                                    <div className="agreement-total">Total Amount to be Billed: $ <span className="agreement-total-underline">{data.totalAmount}</span></div>
                                    <div className="agreement-card-section">
                                        <div className="agreement-card-label">Credit Card Last 4 Digits:</div>
                                        <div className="agreement-card-inputs">
                                            <OtpInput 
                                                numInputs={4} 
                                                onChange={(value) => {
                                                    setCardLast4Digits(value);
                                                }}
                                                value={cardLast4Digits} 
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="agreement-footer">
                                <div className="agreement-client-info">
                                    <div className="agreement-section-title">Client Information</div>
                                    {clientInfo?.company && <div className="agreement-field">Company: {clientInfo?.company}</div>}
                                    {clientInfo?.email && <div className="agreement-field">Email: {clientInfo?.email}</div>}
                                    {clientInfo?.phone && <div className="agreement-field">Phone: {formatPhoneNumberIntl(clientInfo?.phone)}</div>}
                                    <div className="agreement-field">Address: {clientInfo?.address}</div>
                                    {userSignature && <div className="agreement-field">E-Signature: 
                                        <div>
                                            <img src={userSignature} alt="E-Signature" style={{maxWidth: '225px'}}/>
                                        </div>
                                    </div>}
                                </div>
                                <div className="agreement-company-info">
                                    <div className="agreement-section-title">{findIsHostShipAi() ? findConfiguration('COMPANY_NAME_TENANT2', minAmountRechargeConfig) : findConfiguration('COMPANY_NAME_TENANT1', minAmountRechargeConfig)}</div>
                                    <div className="company-contact">Email: info@3plvision.com</div>
                                    <div className="company-contact">Website: <a href="https://www.3plvision.com/" target="_blank" rel="noopener noreferrer">https://www.3plvision.com/</a></div>
                                    <div>Address: 295 Whitehead Road,<br/>Hamilton, New Jersey 08619</div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className="main_content_table incomingTbl summaryTable">
                            <div className=''>
                                <div className='row'>
                                    <div className='col col-6'>Recharge Amount ($)</div>
                                    <div className='col col-6'>{formatNumberWithCommas(data?.amount)}</div>
                                </div>
                                <div className='row'>
                                    <div className='col col-6'>Processing Fees ($)</div>
                                    <div className='col col-6'>{formatNumberWithCommas(data?.commissionAmount)}</div>
                                </div>
                                <div className='row'>
                                    <div className='col col-6'>Total Amount ($)</div>
                                    <div className='col col-6'>{data?.totalAmount}</div>
                                </div>
                                <div className='row'>
                                    <div className='col col-6'>Seller Name</div>
                                    <div className='col col-6'>{userDetails?.Value?.sellerName}</div>
                                </div>
                                <div className='row'>
                                    <div className='col col-6'>Paid To</div>
                                    <div className='col col-6'>{findIsHostShipAi() ? findConfiguration('COMPANY_NAME_TENANT2', minAmountRechargeConfig) : findConfiguration('COMPANY_NAME_TENANT1', minAmountRechargeConfig)}\CrossCultureMall</div>
                                </div>
                                <div className='row acceptTcBox'>
                                    <div className='col-1'>
                                        <input className='agreeTnC' type='checkbox' checked={agreeTnC} onChange={(e) => setAgreeTnC(e.target.checked)} />
                                    </div>
                                    <div className='col-11'>
                                        <div className='mt10'>
                                            Please note that all payments made for {findIsHostShipAi() ? findConfiguration('COMPANY_NAME_TENANT2', minAmountRechargeConfig) : findConfiguration('COMPANY_NAME_TENANT1', minAmountRechargeConfig)} are non-refundable. Once a payment is processed, it is considered final, and no refunds will be issued, regardless of the circumstances. By proceeding with your purchase, you acknowledge and agree to this non-refundable policy.
                                            By clicking the checkbox, you acknowledge that you have read and agree to the terms and conditions of this service. Please review the details carefully before proceeding.
                                        </div>
                                    </div>
                                </div>

                                <div className='rechargeAction'>
                                    <Button
                                        className="cus-primary-transparent-btn top-btn"
                                        onClick={() => navigate(-1)}
                                    >Back</Button>

                                    <button
                                        className="btn cus-seconday-bg-btn top-btn"
                                        onClick={() => recharge()}
                                        disabled={!agreeTnC}
                                    >Recharge</button>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </main>
    );
}

export default Recharge;